if (!customElements.get('cart-drawer')) {

  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.drawer = document.getElementById('cart-drawer');
      this.header = document.querySelector('sticky-header');
      this.cartNote = this.querySelector('cart-note');
      this.openCart = document.querySelector('[data-action="open-cart"]');
      this.closeCart = this.querySelector('[data-action="close-cart"]');
      this.pageOverlay = document.querySelector('.PageOverlay');
      this.upsellAddBtn = this.querySelector('.CartDrawer__UpsellButton');
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.quantityInput = this.querySelectorAll('.quantity__input');
      this.checkoutButton = this.querySelector('.CartDrawer__Checkout');
      this.cartItems = this.querySelector('cart-items');
      this.cartForm = this.querySelector('#cart-drawer-inner');

      this.openCart.addEventListener('click', this.open.bind(this));
      this.closeCart.addEventListener('click', this.close.bind(this))
      this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

      if (this.upsellAddBtn) {
        this.upsellAddBtn.addEventListener('click', this.upsellAddToCart.bind(this));
      }

      if (this.quantityInput) {
        this.disableButtonOnQuantityFocus();
      }

      this.checkSearchParams();

      if (this.checkoutButton) {
        this.checkoutButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.setPropertyForFS();
        })
      }
    }

    open(event) {
      if (event) event.preventDefault();
      if (this.drawer.getAttribute('aria-hidden') === 'false') return

      document.querySelector('body').style.overflow = "hidden";
      document.querySelector('body').classList.add('drawer-opened');
      this.pageOverlay.classList.add('is-visible');
      this.drawer.setAttribute('aria-hidden', 'false');

      this.drawer.addEventListener('transitionend', () => {
        this.drawer.focus();
        trapFocus(this.drawer);
      }, { once: true });

      document.body.addEventListener('click', this.onBodyClick);

      gtag("event", "view_cart", {
        currency: "USD",
        value: Number(this.getAttribute('data-cart-total'))
      });

    }

    close() {
      this.pageOverlay.classList.remove('is-visible');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.querySelector('body').style.overflow = "visible";
      document.body.removeEventListener('click', this.onBodyClick);
      document.querySelector('body').classList.remove('drawer-opened');
      removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (parsedState.status) return

        if (document.getElementById(section.id)) {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }));

      this.clearCartNote();
      this.clearSessionStorageGift();
      this.open();
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#cart-drawer'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target !== this.drawer && target !== this.openCart && !target.closest('cart-drawer') && !target.closest('[data-action=open-cart]')) {
        this.close();
      }
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    upsellAddToCart(event) {
      if (event) event.preventDefault();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const body = JSON.stringify({
        items: [{
          'id': event.target.getAttribute('data-product-id'),
          'quantity': 1
        }],
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      config.body = body;
      this.fetchCart(routes.cart_add_url, config, true);
    }

    fetchCart(url, config, updateCart, successCallback, catchCallback, finallyCallback) {
      if (this.checkoutButton) this.checkoutButton.classList.add('disabled');

      fetch(url, config)
        .then((response) => response.json())
        .then(response => {
          if (successCallback) successCallback(response);
          if (updateCart) this.renderContents(response);
        })
        .catch((error) => {
          if (catchCallback) catchCallback();
          console.log(error);
        })
        .finally(() => {
          if (finallyCallback) finallyCallback();
        });
    }

    checkSearchParams() {
      const params = new URLSearchParams(window.location.search);

      if (params.has('cart')) {
        params.delete('cart');
        this.open();
        let deletePathName = params.toString().length ? `?${params.toString()}` : '';
        let newUrl = `${window.location.origin}${window.location.pathname}${deletePathName}`;
        window.history.pushState(null, null, newUrl);
      }
    }

    clearCartNote() {
      const checkEmptyCart = this.drawer.querySelector('.CartDrawer__Empty');
      const getStorageNote = sessionStorage.getItem('cartNote');

      if (checkEmptyCart && getStorageNote) {
        this.cartNote.fetchNote(false, true);
        sessionStorage.removeItem('cartNote');
      }
    }

    clearSessionStorageGift() {
      const checkEmptyCart = this.drawer.querySelector('.CartDrawer__Empty');
      const getStorageNote = sessionStorage.getItem('removeGwp');

      if (checkEmptyCart && getStorageNote) {
        sessionStorage.removeItem('removeGwp');
      }
    }

    // Disable checkout button when quantity input on focus (fix bug when user can buy less than 3 bottles)
    disableButtonOnQuantityFocus(container) {
      const _this = this;
      this.quantityInput.forEach((item) => {
        item.addEventListener('focus', function () {
          _this.checkoutButton.classList.add('disabled');
        })
      })

      this.quantityInput.forEach((item) => {
        item.addEventListener('blur', function () {
          _this.checkoutButton.classList.remove('disabled');
        })
      })
    }

    setPropertyForFS() {
      const fsPropertyEvent = this.cartItems.getAttribute('data-fs-property');
      const firstLineItem = this.cartItems.querySelector('.CartItem:not(.CartItem__Gwp) .quantity__input');

      if (!firstLineItem) return;
      const firstLineItemKey = firstLineItem.getAttribute('data-key');
      let firstLineItemQuantity = firstLineItem.value;
      let properties = {'_free_shipping': 'false'};

      if (firstLineItem.hasAttribute('data-bundle-quantity')) {
        firstLineItemQuantity = firstLineItem.getAttribute('data-bundle-quantity');
      }

      if (firstLineItem.getAttribute('data-item-properties')) {
        const firstLineItemProperties = JSON.parse(firstLineItem.getAttribute('data-item-properties'));
        Object.assign(properties, firstLineItemProperties);
      }

      if (fsPropertyEvent === 'add' && firstLineItemKey) {
        properties._free_shipping = 'true';
        this.cartItems.updateQuantity(firstLineItemKey, firstLineItemQuantity, properties, false, null, true);
      } else if (fsPropertyEvent === 'remove' && firstLineItemKey) {
        properties._free_shipping = 'false';
        this.cartItems.updateQuantity(firstLineItemKey, firstLineItemQuantity, properties, false, null, true);
      } else {
        window.location.href = '/checkout'
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}


if (!customElements.get('cart-remove-button')) {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.giftProduct = this.getAttribute('data-remove-gift');
      this.giftSubsProduct = this.getAttribute('data-remove-subs-gift');
      this.isBundle = this.hasAttribute('data-bundle-remove');
      let bundleData = null;

      if (this.isBundle) {
        let updateData = JSON.parse(this.closest('[data-bundle]')?.getAttribute('data-bundle'));
        Object.keys(updateData).forEach(key => updateData[key] = 0);

        bundleData = {
          updates: updateData
        }
      }

      this.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.giftProduct) {
          sessionStorage.setItem('removeGwp', 'true');
        } else if (this.giftSubsProduct) {
          sessionStorage.setItem('removeSubsGwp', 'true');
        }
        this.closest('cart-items').updateQuantity(this.dataset.key, 0, null, true, bundleData);
      });
    }
  }

  customElements.define('cart-remove-button', CartRemoveButton);
}


if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer = this.closest('cart-drawer');
      this.checkoutBtn = this.cartDrawer.querySelector('.CartDrawer__Checkout');
      this.onlyGwpInCart = this.querySelector('[data-only-gift-in-cart]');
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.cartItemQuantity = this.querySelectorAll('.cart-quantity');
      this.cartItemQuantity.forEach((item => {
        item.addEventListener('change', this.debouncedOnChange.bind(this));
      }))

      // remove first order gwp if only it in cart
      if (this.onlyGwpInCart) {
        const gwpKey = this.onlyGwpInCart.getAttribute('data-key');
        this.updateQuantity(gwpKey,0);
        sessionStorage.removeItem('fo_gwp');
      }
    }

    onChange(event) {
      let bundleData = null;
      if (event.target.hasAttribute('data-bundle-quantity')) {
        let updateData = JSON.parse(event.target.closest('[data-bundle]')?.getAttribute('data-bundle'));
        Object.keys(updateData).forEach(key => updateData[key] = +event.target.value * +updateData[key]);
        bundleData = {
          updates: updateData
        }
      }

      event.target.closest('.cart-quantity').classList.add('disabled')
      this.updateQuantity(event.target.dataset.key, event.target.value, null, true, bundleData);
    }

    updateQuantity(key, quantity, properties = {}, renderContents = true, bundleData = null, checkoutRedirect = false) {
      const url = bundleData ? routes.cart_update_url : routes.cart_change_url

      this.checkoutBtn.classList.add('disabled');

      let body = {
        id: key,
        quantity: quantity,
        properties: properties
      };

      if (bundleData) {
        body = bundleData
      }

      if (renderContents) {
        body.sections =  this.cartDrawer.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      body = JSON.stringify(body);
      fetch(url, {...fetchConfig('javascript'), ...{body}})
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (renderContents) {
            this.cartDrawer.renderContents(response)
          } else {
            this.checkoutBtn.classList.remove('disabled');
          }

          if (checkoutRedirect) {
            window.location.href = '/checkout'
          }
        })
        .catch(() => {})
        .finally(() => {
          if (checkoutRedirect) {
            window.location.href = '/checkout';
          }
        });
    }
  }

  customElements.define('cart-items', CartItems);
}

if (!customElements.get('cart-selling-plan')) {
  class CartSellingPlan extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer = this.closest('cart-drawer');
      this.select = this.querySelector('.CartItem__SellingPlanSelect');
      this.key = this.getAttribute('data-key');
      this.lineQuantity = this.getAttribute('data-line-quantity');
      this.checkoutBtn = this.cartDrawer.querySelector('.CartDrawer__Checkout');

      this.select.addEventListener('change', this.updateSellingPlan.bind(this));
    }

    updateSellingPlan() {
      const body = JSON.stringify({
        id: this.key,
        quantity: this.lineQuantity,
        selling_plan: this.select.value,
        sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      this.checkoutBtn.setAttribute('disabled', 'disabled');
      this.cartDrawer.fetchCart(routes.cart_change_url, {...fetchConfig(), ...{body}}, true);
    }
  }

  customElements.define('cart-selling-plan', CartSellingPlan);
}

if (!customElements.get('cart-item-subscribe')) {
  class CartItemSubscribe extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer = this.closest('cart-drawer');
      this.cartOverlay = this.cartDrawer.querySelector('.CartOverlay');
      this.openBtn = this.querySelector('.CartItem__SubscribeBtn');
      this.closeBtn = this.querySelector('.SubscribePopup__Close');
      this.popup = this.querySelector('.SubscribePopup');
      this.submit = this.querySelector('.SubscribePopup__Submit');

      this.openBtn.addEventListener('click', this.openPopup.bind(this));
      this.closeBtn.addEventListener('click', this.closePopup.bind(this));
      this.cartOverlay.addEventListener('click', this.closePopup.bind(this));
      this.submit.addEventListener('click', this.addSellingPlan.bind(this));
    }

    openPopup() {
      this.cartOverlay.classList.add('is-visible');
      this.popup.setAttribute('aria-hidden', 'false');
    }

    closePopup() {
      this.cartOverlay.classList.remove('is-visible');
      this.popup.setAttribute('aria-hidden', 'true');
    }

    addSellingPlan() {
      const planId = this.querySelector('input:checked').value;
      const key = this.getAttribute('data-key');
      const quantity = this.getAttribute('data-line-quantity');
      const discountPerItem = this.getAttribute('data-discount-per-item');

      this.closePopup();

      const body = JSON.stringify({
            id: key,
            quantity: quantity,
            selling_plan: planId,
            properties: {'_subscription_discount_per_item': discountPerItem},
            sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          });

      this.cartDrawer.fetchCart(routes.cart_change_url, {...fetchConfig(), ...{body}}, true);

    }
  }

  customElements.define('cart-item-subscribe', CartItemSubscribe);
}


document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('cart-ship-date')) {
    class CartShipDate extends HTMLElement {
      constructor() {
        super();
        this.openPopupBtn = this.querySelector('.js-ship-popup-open');
        this.closePopupBtn = this.querySelector('.js-ship-popup-close');
        this.popupWrapper = this.querySelector('.js-ship-popup-wrapper');
        this.shipAsapBtn = this.querySelector('.js-ship-asap-btn');
        this.popup = this.popupWrapper.querySelector('.js-ship-popup');
        this.deliveryInfo = this.popupWrapper.querySelector('.js-ship-selected-info');
        this.selectedDate = this.popupWrapper.querySelector('.js-ship-selected-date');
        this.hiddenInput = this.popupWrapper.querySelector('.js-ship-input-hidden');
        this.submitBtn = this.querySelector('.js-ship-date-submit');


        this.openPopupBtn.addEventListener('click', () => {
          this.popupWrapper.classList.add('is-visible');
        })

        this.closePopupBtn.addEventListener('click', () => {
          this.closePopup();
        })

        this.popupWrapper.addEventListener('click', (e) => {
          let isClickInside = this.popup.contains(e.target);
          if (!isClickInside) {
            this.closePopup()
          }
        });

        this.submitBtn.addEventListener('click', () => {
          this.onSubmit();
        })

        this.shipAsapBtn.addEventListener('click', () => {
          this.updateCartAttributes();
          this.querySelector('.js-custom-select-btn').textContent = this.shipAsapBtn.textContent;
          this.openPopupBtn.textContent = this.openPopupBtn.getAttribute('data-option-value');
          this.deliveryInfo.classList.remove('is-visible');
          this.hiddenInput.value = '';
        })

        this.initDatepicker();
      }



      initDatepicker () {
        const _this = this;

        flatpickr("#CartShipDatePicker", {
          inline: true,
          defaultDate: this.hiddenInput.value,
          minDate: new Date().fp_incr(1),
          maxDate: new Date().fp_incr(15),
          dateFormat: "m/d/Y",
          disable: [
            function(date) {
              return (date.getDay() === 0 || date.getDay() === 6);
            }
          ],
          locale: {
            firstDayOfWeek: 1
          },
          onChange: function(selectedDates, dateStr, instance) {
            _this.onDateChange(dateStr)
          },
          onReady: function(selectedDates, dateStr, instance) {
            if (_this.hiddenInput.value) {
              _this.onDateChange(_this.hiddenInput.value);
            }
          }
        });
      }

      closePopup () {
        this.popupWrapper.classList.remove('is-visible');
        console.log(this.hiddenInput.value)
        if (!this.hiddenInput.value) {
          this.shipAsapBtn.click();
        }
      }

      onDateChange (date) {
        if (!date) return;
        const parts = date.split("/");
        const month = parseInt(parts[0], 10) - 1;
        const day = parseInt(parts[1], 10);
        const dateObj = new Date(2025, month, day);
        const options = { month: "long", day: "numeric" };
        const formatted = dateObj.toLocaleDateString("en-US", options);

        this.deliveryInfo.classList.add('is-visible');
        this.selectedDate.textContent = formatted;
        this.hiddenInput.value = date;
        this.submitBtn.removeAttribute('disabled');
      }

      onSubmit() {
        this.querySelector('.js-custom-select-btn').textContent = this.hiddenInput.value;
        this.openPopupBtn.textContent = this.hiddenInput.value;
        this.closePopup();
        this.updateCartAttributes(this.hiddenInput.value);
      }

      updateCartAttributes(date) {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Ship Date': date ? date : ''
            }
          })
        })
          .then(res => res.json())
          .then(data => {

          })
          .catch(err => {
            console.error(err);
          });
      }
    }

    customElements.define('cart-ship-date', CartShipDate);
  }
})
